import React, { useEffect, useState } from "react";
import "./style.scss";
import imageNot1 from "assets/noticias/1/1.png";
import imageNot2 from "assets/noticias/2/2.jpg";
import imageNot3 from "assets/noticias/3/3.jpg";
import imageNot4 from "assets/noticias/4/4.jpg";
import imageNot5 from "assets/noticias/5/5.jpg";
import imageNot6 from "assets/noticias/6/6.jpg";
import { api } from "services/api";
import { handleOpenTab, PORTAL_PUBLICO_BASE_URL } from "utils";

export const NewsPage: React.FC = () => {
	const [news, setNews] = useState<any[]>([]);
	const [newsFeedback, setNewsFeedback] = useState<any>();
	useEffect(() => {
		api.get("/news/private").then((result) => {
			const {
				data: {
					data: { news },
					feedback,
				},
			} = result;
			setNewsFeedback(feedback);
			setNews(news);
		});
	}, []);
	const imageNotArr = [
		imageNot1,
		imageNot2,
		imageNot3,
		imageNot4,
		imageNot5,
		imageNot6,
	];
	return (
		<div className="news">
			<div className="news__container">
				<h1 className="news__container__title">NOTÍCIAS</h1>
				<div className="news__container__items">
					{news.length !== 0 &&
						news.map((item, index) => {
							return (
								<div
									className="news__container__items__card"
									onClick={() =>
										handleOpenTab(
											PORTAL_PUBLICO_BASE_URL,
											"/news/",
											`${item.id}`
										)
									}
								>
									<img
										src={item.image ? item.image : imageNotArr[index]}
										alt=""
										width="200px"
									/>
									<div className="news__container__items__card__info">
										<h1>{item.title}</h1>
										<p>
											{item.description.length > 120
												? `${item.description.substring(0, 120)}...`
												: item.description}
										</p>
									</div>
								</div>
							);
						})}
					{news.length === 0 && (
						<h1
							style={{
								fontSize: "30px",
								fontFamily: "Montserrat",
								fontWeight: "300",
							}}
						>
							{newsFeedback
								? newsFeedback["empty"]
								: "Sem notícias para exibir."}
						</h1>
					)}
				</div>
			</div>
		</div>
	);
};
